// JavaScript Document

import { Game } from "phaser";
const playerState={
  state: 'idle',
  direct: 'left',
  Jump: false,
  JumpDown: false,
  idle: false
}

//const graphics = this.add.graphics();
//graphics.lineStyle(1, 0xff0000)
//graphics.fillStyle(0xFF00FF, 1)
//const ellipse = new Phaser.Curves.Ellipse(200, 200, 100, 50, 0, 90)
//ellipse.draw(graphics)

//"esversion : 6";
export default class MainScene extends Phaser.Scene {
  constructor() {
    super({ key: 'MainScene' })
  }

   
  preload () {
    //this.load.image('bg', './background.png');
    this.score = 0;
  }

  create() {
    this.add.image(0, 0, 'bg').setOrigin(0, 0);
		this.add.image(400, 568, 'ground');
        //this.add.image(400, 300, 'logo');
        //this.add.image(100, 450, 'dude');
        var particles = this.add.particles('red');
        
		//LOGO彈跳發射器
        var emitter = particles.createEmitter({
            speed: 100,
            scale: { start: 1, end: 0 },
            blendMode: 'ADD'
        });
        var logo = this.physics.add.image(400, 100, 'logo');
        logo.setVelocity(100, 200);
        logo.setBounce(1, 1);
        logo.setCollideWorldBounds(true);
        emitter.startFollow(logo);
		
		//這一段建立站立平台
		this.platforms = this.physics.add.staticGroup();
		this.platforms.create(400, 568, 'ground').setScale(6,1).refreshBody();
		this.platforms.create(600, 400, 'ground');
		this.platforms.create(300, 420, 'ground');
        this.platforms.create(50, 250, 'ground');
        this.platforms.create(750, 220, 'ground');
		
		//這一段設定玩家
		//this.player.physics.add.sprite(100, 450, 'dude')
		//.setBounce(0.2)
		//.setCollideWorldBounds(true);
		this.player = this.physics.add.sprite(400, 450, 'dude')
    .setBounce(0.2)
    .setCollideWorldBounds(true);
		//console.log('Player:', this.player);
        //下面動畫設定已寫在preload.js----------------------------------
		//this.anims.create({
			//key: 'left',
			//frames: this.anims.generateFrameNumbers('dude', {start: 0, end: 3}),
			//frameRate: 10,
			//repeat: -1
		//})
		//this.anims.create({
			//key: 'turn',
			//frames: [{key: 'dude', frame: 4}],
			//frameRate: 20
		//})
		//this.anims.create({
			//key: 'right',
			//frames: this.anims.generateFrameNumbers('dude', {start: 5, end: 8}),
			//frameRate: 10,
			//repeat: -1
		//})
    


		//---------------------------------------------------------------------


		//為玩家及地板建立碰撞器
		this.physics.add.collider(this.player, this.platforms);

    


		
		//鍵盤控制器
    this.cursors = this.input.keyboard.createCursorKeys()

    this.stars = this.physics.add.group({
      key: 'star',
      repeat: 11,
      setXY: { x: 12, y: 0, stepX: 70 }
    })

    this.stars.children.iterate(function (child) {
      child.setBounceY(Phaser.Math.FloatBetween(0.4, 0.8))
    })
    //撿拾星星
    this.physics.add.collider(this.stars, this.platforms)
    //判斷是否重疊overlap 如是就執行 collectStar
    this.physics.add.overlap(this.player, this.stars, collectStar, null, this)
    //計分板製作
    //this.game.data.set('score',this.score);
    
    this.scoreText = this.add.text(16, 16, 'Score: 0', {
      color: '#fff',
      resolution: 2,
      fontFamily: 'Tahoma'
    })
	  
    //增加炸彈
    this.bombs = this.physics.add.group({
      key: 'bomb',
			repeat: Phaser.Math.FloatBetween(2, 6),
			setXY: {x: Phaser.Math.FloatBetween(5, 200), y: 0 , stepX: Phaser.Math.FloatBetween(150, 250)}
    })


    this.physics.add.collider(this.bombs, this.platforms)
    this.physics.add.collider(this.player, this.bombs, hitBomb, null, this)

    playerState.direct= 'left';//設定一開始面向左邊
    changePlayerState('JumpDown',this.player);

    this.over = this.tweens.add({
      targets: this.player,
      y: '+=600',
      duration: 5000,
      paused: true,
      ease: 'Bounce.easeOut'
    })
  }

  update() {
	  //console.log(playerState.direct, playerState.state);
     if (playerState.state === 'Hurt') { return;}
     //鍵盤控制 
     if (this.cursors.left.isDown) {
       this.player.setVelocityX(-160)
       playerState.direct= 'left';
       playerState.state= 'Run';
       if (this.player.body.touching.down){
          changePlayerState('Run',this.player);
       }else{
          if (this.player.body.velocity.y > 2 ){ 
            changePlayerState('JumpDown',this.player);
          }else if (this.player.body.velocity.y < -2){
            changePlayerState('Jump',this.player);
          }
       }
     } else if (this.cursors.right.isDown) {
       this.player.setVelocityX(160)
       playerState.direct= 'right';
       playerState.state= 'Run';
       if (this.player.body.touching.down){
        changePlayerState('Run',this.player);
       }else{
        if (this.player.body.velocity.y > 2 ){ 
          changePlayerState('JumpDown',this.player);
        }else if (this.player.body.velocity.y < -2){
          changePlayerState('Jump',this.player);
        }
       }
     } else {
       this.player.setVelocityX(0);
       if (playerState.state !== 'idle' && this.player.body.touching.down){
         changePlayerState('idle', this.player);
       }else if(this.player.body.velocity.y>2){
         changePlayerState('JumpDown',this.player);//自由落下時
       }
     }

     if (this.cursors.up.isDown && this.player.body.touching.down) {
       changePlayerState('Jump', this.player);
       this.player.setVelocityY(-330);
     }
    }

  }

function hitBomb (player, bomb){
  //當觸碰了炸彈
  
  player.setTint(0xff0000)
  playerState.state="Hurt";
  if (playerState.direct==='left'){player.anims.play('leftHurt');
  }else{player.anims.play('rightHurt');}
  
  this.physics.pause()
  this.over.play()
  
  setTimeout(() => {
    this.pausePhysics = false;
    //console.log("this.paused=",this.paused);
    //alert("解除暫停，並更換場景");
    recordScore(this.score);
    this.scene.start('EndScene');
  }, 2000)
  
}


function collectStar (player, star) {
  //當接觸了星星，取消碰撞，隱藏，
  star.disableBody(true, true)
	//計分加分動作
  this.score += 10
  this.scoreText.setText(`Score: ${this.score}`)
  if (this.stars.countActive(true) === 0){
    this.stars.children.iterate(function (child) {
      child.enableBody(true, child.x, 0, true, true);
    })

    const x = (player.x < 400) ? Phaser.Math.Between(400, 800) : Phaser.Math.Between(0, 400);

    const bomb = this.bombs.create(x, 16, 'bomb');
    bomb.setBounce(1);
    bomb.setCollideWorldBounds(true);
    bomb.setVelocity(Phaser.Math.Between(-200, 200), 20);
  }
}



function recordScore(finalScore){
  //因為網上改變場景均有問題，目前用HTML 的TESTDIV紀錄值
  const testDiv1= document.getElementById('testDiv');
  testDiv1.innerText = finalScore;
}


function changePlayerState(InSel, Player){
  //const 宣告為常數不可再改變內容，let 還可以改，迴圈可用，var 最弱最隨意的宣告
 
  console.log(InSel , Player.body.velocity.y, Player.body.touching.down);

  if (InSel === 'idle'){
    Player.anims.play('turn');
    playerState.Jump= false;
    playerState.JumpDown= false;
    playerState.idle= true;
    playerState.state= 'idle';
  }else if (InSel === 'Jump'){
    if (playerState.direct === 'left'){Player.anims.play('leftJump');
    }else{Player.anims.play('rightJump');   }
    playerState.Jump= true;
    playerState.JumpDown= false;
    playerState.idle= false;
    playerState.state= 'Jump';
  }else if (InSel === 'JumpDown'){
    if (playerState.direct === 'left'){Player.anims.play('leftJumpDown');
    }else{Player.anims.play('rightJumpDown');   }
    playerState.Jump= false;
    playerState.JumpDown= true;
    playerState.idle= false;
    playerState.state= 'JumpDown';
  }else if (InSel === 'Run' ){
    if (playerState.direct === 'left'){Player.anims.play('left');
    }else{Player.anims.play('right');
    }
    playerState.Jump= false;
    playerState.JumpDown= false;
    playerState.idle= false;
  }


}